
import MoreSquare from "../../../assets/outline/MoreSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoreSquareIcon({ className, dataTestid = "MoreSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoreSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
